import { EventChannel, eventChannel } from "redux-saga";

export const  createOnlineOfflineChannel=():EventChannel<boolean> => {
  return eventChannel<boolean>((emit) => {
    const onlineHandler = () => emit(true);
    const offlineHandler = () => emit(false);

    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);
    emit(navigator.onLine);

    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  });
}
